import React, { useLayoutEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import i18n from 'i18next'

import { FooterContainer } from 'components/FooterContainer'
import { Header } from 'components/Header'
import { Spinner } from 'components/Spinner'

import {
  REFUND_SUBSCRIPTION,
  applySubscriptionRefundOfferAction,
  getSubscriptionRefundOfferAction,
  setUUIDAction,
} from 'root-redux/actions/user'
import {
  selectActionList,
  selectAppName,
  selectRefundAmount,
} from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import {
  APP_COLORS_DATA,
  APP_IMAGES_DATA,
} from 'modules/unsubscribe/pages/AcceptRefund/constants'

import { eventLogger } from 'services/eventLogger.service'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'
import { Language } from 'root-constants'

import { StyledAcceptRefund as S } from './AcceptRefund.styles'
import { StatusModal } from './components'

export const AcceptRefund: React.FC = () => {
  const { t } = useTranslation()
  const { search } = useLocation()
  const dispatch: TAppDispatch = useDispatch()
  const appName = useSelector(selectAppName)
  const lang = new Intl.Locale(i18n.language).language || Language.EN
  const refundValue = useSelector(selectRefundAmount)
  const fetchingActionsList = useSelector(selectActionList)
  const [token, setToken] = useState<string>('')

  const isRefundSubscriptionInProgress =
    fetchingActionsList.includes(REFUND_SUBSCRIPTION)

  const goToLoginPage = () => {
    goTo(PageId.LOGIN)
  }

  useLayoutEffect(() => {
    const URLParams = new URLSearchParams(search)
    const utmTagsFromUrl = Object.fromEntries(URLParams.entries())
    const refundToken = utmTagsFromUrl.refund_token
    const customerId = utmTagsFromUrl.customer_id

    if (!refundToken || !customerId) {
      goToLoginPage()

      return
    }

    setToken(refundToken)
    dispatch(setUUIDAction(customerId))
    dispatch(getSubscriptionRefundOfferAction(refundToken, customerId))
  }, [dispatch, search])

  const refundSubscription = () => {
    eventLogger.logRefundOfferAccepted(refundValue)
    dispatch(applySubscriptionRefundOfferAction(token, refundValue))
  }

  return (
    <>
      {isRefundSubscriptionInProgress && <Spinner />}
      <Header />
      <S.Root>
        <S.ImageContainer>
          <img src={APP_IMAGES_DATA[appName]} alt="refund" />
        </S.ImageContainer>
        <S.Title color={APP_COLORS_DATA[appName]} lang={lang}>
          <Trans i18nKey="acceptRefund.title" values={{ refundValue }} />
        </S.Title>
        <S.Subtitle>
          <Trans i18nKey="acceptRefund.subtitle" values={{ refundValue }} />
        </S.Subtitle>
      </S.Root>
      <FooterContainer>
        <S.Button
          backgroundColor={APP_COLORS_DATA[appName]}
          onClick={refundSubscription}
        >
          {t('acceptRefund.confirm')}
        </S.Button>
      </FooterContainer>
      <StatusModal />
    </>
  )
}
